module.exports = __webpack_public_path__ + "media/favicon/mstile-310x310-0eba8e9d342936235755f6582524b9e6.png";